import CreateEditPriceModal from './CreateEditPriceModal';

export default CreateEditPriceModal;